/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiCustomSchemaField } from './InternalApiCustomSchemaField';
import {
    InternalApiCustomSchemaFieldFromJSON,
    InternalApiCustomSchemaFieldFromJSONTyped,
    InternalApiCustomSchemaFieldToJSON,
    InternalApiCustomSchemaFieldToJSONTyped,
} from './InternalApiCustomSchemaField';

/**
 * a Schema
 * @export
 * @interface InternalApiCustomSchema
 */
export interface InternalApiCustomSchema {
    /**
     * 
     * @type {number}
     * @memberof InternalApiCustomSchema
     */
    id?: number;
    /**
     * 
     * @type {Array<InternalApiCustomSchemaField>}
     * @memberof InternalApiCustomSchema
     */
    fields: Array<InternalApiCustomSchemaField>;
}

/**
 * Check if a given object implements the InternalApiCustomSchema interface.
 */
export function instanceOfInternalApiCustomSchema(value: object): value is InternalApiCustomSchema {
    if (!('fields' in value) || value['fields'] === undefined) return false;
    return true;
}

export function InternalApiCustomSchemaFromJSON(json: any): InternalApiCustomSchema {
    return InternalApiCustomSchemaFromJSONTyped(json, false);
}

export function InternalApiCustomSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCustomSchema {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'fields': ((json['fields'] as Array<any>).map(InternalApiCustomSchemaFieldFromJSON)),
    };
}

export function InternalApiCustomSchemaToJSON(json: any): InternalApiCustomSchema {
    return InternalApiCustomSchemaToJSONTyped(json, false);
}

export function InternalApiCustomSchemaToJSONTyped(value?: InternalApiCustomSchema | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fields': ((value['fields'] as Array<any>).map(InternalApiCustomSchemaFieldToJSON)),
    };
}

